import {Component, Input, OnInit} from '@angular/core';
import {Constants} from '../../utils/constants';

declare var $: any;
@Component({
  selector: 'fx-export-button',
  templateUrl: './export-button.component.html',
  styleUrls: ['./export-button.component.sass'],
})
export class ExportButtonComponent implements OnInit {
  @Input() tableId: string;
  @Input() fileName: string;
  @Input() classes: string;
  @Input() icon: string;
  @Input() text: string;
  @Input() excludeImage = false;
  tableToExcel: any;
  constructor() {}

  ngOnInit() {
    this.tableToExcel = (() => {

      let downloadLink: any;
      downloadLink = document.createElement('a');
      document.body.appendChild(downloadLink);
      // tslint:disable-next-line:one-variable-per-declaration
      const uri = 'data:application/vnd.ms-excel;base64,',
        template = Constants.FILE_DOWNLOAD_TEMPLATE.EXCEL,
        base64 = (s: any) => {
          return window.btoa(unescape(encodeURIComponent(s)));
        },
        format = (s: any, c: any) => {
          return s.replace(/{(\w+)}/g, (m: any, p: any) => {
            return c[p];
          });
        };
      return () => {
        const table = document.getElementById(this.tableId);
        const clonedTable = $(table).removeClass("d-none").clone(true);
        clonedTable.find('.view-bank-widthdraws').remove()
        clonedTable.find('#banking-withdraws-select').remove()
        if (this.excludeImage) {
          $.each(clonedTable.find('img'), function() {
            $(this).remove();
          });
        }
        const ctx = {
          worksheet: this.fileName || 'Worksheet',
          table: clonedTable.html(),
        };
        if (navigator.msSaveOrOpenBlob) {
          const filename = this.fileName ? this.fileName + '.xls' : 'data.xls';
          const blob = new Blob(['\ufeff', base64(format(template, ctx))], {
            type: uri,
          });
          navigator.msSaveOrOpenBlob(blob, filename);
        } else {
          // Create a link to the file
          downloadLink.href = uri + base64(format(template, ctx));
          // Setting the file name
          downloadLink.download = this.fileName + '.xls';
          // Rriggering the function
          downloadLink.click();
        }
      };
    })();
  }

  export() {
    let downloadLink: any;
    const dataType = 'application/vnd.ms-excel;base64,';
    const tableSelect = document.getElementById(this.tableId);
    const tableHTML = tableSelect.outerHTML.replace(/ /g, '%20');

    // Specify file name
    const filename = this.fileName ? this.fileName + '.xls' : 'data.xls';

    // Create download link element
    downloadLink = document.createElement('a');
    document.body.appendChild(downloadLink);

    if (navigator.msSaveOrOpenBlob) {
      const blob = new Blob(['\ufeff', tableHTML], {
        type: dataType,
      });
      navigator.msSaveOrOpenBlob(blob, filename);
    } else {
      // Create a link to the file
      downloadLink.href = 'data:' + dataType + ', ' + tableHTML;
      // Setting the file name
      downloadLink.download = filename;
      // Rriggering the function
      downloadLink.click();
    }
  }
}
